import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ellipsis",
  "use": "icon-ellipsis-usage",
  "viewBox": "0 0 28 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 6\" id=\"icon-ellipsis\"><path d=\"M25 0a3 3 0 110 6 3 3 0 010-6zM14 0a3 3 0 110 6 3 3 0 010-6zM3 0a3 3 0 110 6 3 3 0 010-6z\" fill=\"#333\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol